// extracted by mini-css-extract-plugin
module.exports = {"navItem":"MenuSidebarItem_navItem__Ggak0","navItemLink":"MenuSidebarItem_navItemLink__yIvUG","active":"MenuSidebarItem_active__1tdj8"};